/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_fa9350cf{display:inline-block;vertical-align:middle;speak:none;width:1em;height:1em}.svg_fa9350cf{height:100%;fill:currentColor;vertical-align:top}"}]);
export const root = "root_fa9350cf";
export const svg = "svg_fa9350cf";